import React from 'react';
import './i18n';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import InsideApp from './inside/InsideApp';
import reportWebVitals from './reportWebVitals';

const isInsideRoute = window.location.pathname === '/inside' ||
  window.location.pathname.startsWith('/inside/');

const rootElement = document.getElementById('root');
if (isInsideRoute && rootElement?.querySelector('#inside-prerender')) {
  rootElement.replaceChildren();
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {isInsideRoute ? <InsideApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
